import { Player } from '../Player'
import { TableSnapshot } from '../Snapshot'
import { BotAction } from './BotPlayerKind.utils'

import { BoardStates } from '../states'
import { BotPlayerKind } from './BotPlayerKind'
import {
  BotActionCallback,
  getBetAmount,
  getRaiseAmount,
  getSoftAction,
  StreetsActions
} from './BotKindPP/StreetActions'
import { Game } from '../Game'
import { ActionHint } from '../ActionEvaluator'

export class BotPlayerKindPP extends BotPlayerKind {
  /**
   *
   * @param mainPot main pot amount
   * @param playerChips player chips
   * @returns the amount to bet
   */
  betAmount(args: {
    mainPot: number
    playerChips: number
    bigBlindAmount: number
  }): number {
    return getBetAmount(args)
  }
  /**
   *
   * @param biggestBet last biggest bet
   * @param playerChips player chips
   * @param boardState board state
   * @see {@link BoardStates} for the possible board state values
   * @returns the amount to raise
   */
  raiseAmount(args: { biggestBet: number; playerChips: number }): number {
    return getRaiseAmount(args)
  }
  getAction({ game, table, player }: { game: Game; player: Player; table: TableSnapshot }): BotAction {
    type BoardStateKey = Extract<typeof table.boardState, 'deal' | 'flop' | 'turn' | 'river'>
    type BoardActionState = Record<BoardStateKey, BotActionCallback>

    const boardStateAction: BoardActionState = {
      deal: StreetsActions.PreFlop,
      flop: StreetsActions.Flop,
      turn: StreetsActions.Turn,
      river: StreetsActions.River
    }

    const boardState = table.boardState as BoardStateKey
    const actionToPerform = boardStateAction[boardState]
    const botAction = actionToPerform({ player, table, game })
    console.log('LOG: > getAction > player.cards:', player.cards)
    console.log('LOG: > getAction > botAction:', botAction)
    console.log('LOG: > getAction > player.actions:', player.actions)
    //
    if (
      botAction.action === ActionHint.BET &&
      !player.actions.includes(ActionHint.BET) &&
      player.actions.includes(ActionHint.RAISE)
    ) {
      // trying to bet when it should raise, mutate action
      botAction.action = ActionHint.RAISE
    }

    try {
      const checkAllInValidAction =
        botAction.action === ActionHint.ALLIN &&
        (player.actions.includes(ActionHint.BET) || player.actions.includes(ActionHint.RAISE))

      if (!player.actions.includes(botAction.action)) {
        if (checkAllInValidAction) {
          return botAction
        }
        throw new Error("Player can't perform action")
      }
      return botAction
    } catch (error) {
      console.warn('BotPlayerKindPP action error', error)
      return getSoftAction({ player })
    }
  }
}
